import { render, staticRenderFns } from "./ExamManagementHeader.vue?vue&type=template&id=5c83e0db"
import script from "./ExamManagementHeader.vue?vue&type=script&lang=js"
export * from "./ExamManagementHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports